import {Directive, inject, input, TemplateRef, WritableSignal} from '@angular/core';
import {SIGNAL} from "@angular/core/primitives/signals";

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[templateFor]'
})
export class TemplateForDirective {

  readonly name = input.required<string>({alias: 'templateFor'});
  readonly template = inject(TemplateRef<unknown>);

  getType(): string {
    return this.name();
  }


  static Bind<T>(item: InferTemplateProps<T>, queryList: readonly TemplateForDirective[] | undefined) {
    if (!queryList) {
      console.error('No query list')
      return;
    }
    queryList.forEach((template: TemplateForDirective) => {
      const name = template.getType();
      if (!(name in item)) {
        return;
      }
      const existing = (item as Record<string, object|WritableSignal<unknown>>)[name];
      if (existing && typeof existing === 'function' && SIGNAL in existing) {
          existing.set(template.template);
        return;
      }
      (item as Record<string, unknown>)[name] = template.template;

    })
  }

}

type TemplateRefKeys<T> = {
  [K in keyof T]: T[K] extends TemplateRef<unknown> ? K : never;
}[keyof T];

type RestrictedIndexSignature<T> = Record<TemplateRefKeys<T>, TemplateRef<unknown>>;

export type InferTemplateProps<T> = {
  [K in keyof T as T[K] extends TemplateRef<unknown> ? K : never]: T[K];
} & RestrictedIndexSignature<T>;

